import React from 'react';
import styled from 'styled-components';
import logo from '../assets/logo3.png'; 

const Loader = () => {
  return (
    <StyledWrapper>
      <div className="loader">
        <div className="box">
          <div className="logo">
            <img src={logo} alt="Loading Logo" />
          </div>
        </div>
        <div className="box" />
        <div className="box" />
        <div className="box" />
        <div className="box" />
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #fafafa; 

  .loader {
    --size: 250px;
    --duration: 2.5s; /* Slightly increased duration for a more relaxed, elegant feel */
    --background: linear-gradient(
      0deg,
      rgba(241, 89, 6, 0.08) 0%,
      rgba(255, 122, 51, 0.20) 100%
    );
    height: var(--size);
    aspect-ratio: 1;
    position: relative;
  }

  .loader .box {
    position: absolute;
    background: var(--background);
    border-radius: 50%;
    border: 1px solid rgba(241, 89, 6, 0.15); 
    border-top: 2px solid rgba(241, 89, 6, 1); 
    backdrop-filter: blur(5px);
    
    /* ADDED: Hardware acceleration for buttery smooth rendering */
    will-change: transform, box-shadow; 
    
    /* UPDATED: Custom cubic-bezier for a much more organic, fluid motion */
    animation: ripple var(--duration) infinite cubic-bezier(0.45, 0.05, 0.55, 0.95);
  }

  .loader .box:nth-child(1) {
    inset: 35%; 
    z-index: 99;
  }

  .loader .box:nth-child(2) {
    inset: 25%;
    z-index: 98;
    border-top-color: rgba(241, 89, 6, 0.9);
    animation-delay: 0.2s;
  }

  .loader .box:nth-child(3) {
    inset: 15%;
    z-index: 97;
    border-top-color: rgba(241, 89, 6, 0.75);
    animation-delay: 0.4s;
  }

  .loader .box:nth-child(4) {
    inset: 5%;
    z-index: 96;
    border-top-color: rgba(241, 89, 6, 0.55);
    animation-delay: 0.6s;
  }

  .loader .box:nth-child(5) {
    inset: -5%;
    z-index: 95;
    border-top-color: rgba(241, 89, 6, 0.4);
    animation-delay: 0.8s;
  }

  .loader .logo {
    position: absolute;
    inset: 0;
    display: grid;
    place-content: center;
    padding: 10%; 
  }

  .loader .logo img {
    width: 100%;
    height: auto;
    
    /* ADDED: Hardware acceleration for the logo image */
    will-change: transform, opacity;
    
    /* UPDATED: Matches the fluid easing of the rings */
    animation: logo-pulse var(--duration) infinite cubic-bezier(0.45, 0.05, 0.55, 0.95);
  }

  /* UPDATED: Added translateZ(0) to force GPU rendering and eliminate micro-stutters */
  @keyframes ripple {
    0%, 100% {
      transform: scale(1) translateZ(0);
      box-shadow: rgba(241, 89, 6, 0.2) 0px 10px 15px -0px;
    }
    50% {
      transform: scale(1.3) translateZ(0);
      box-shadow: rgba(241, 89, 6, 0.5) 0px 25px 25px -0px;
    }
  }

  @keyframes logo-pulse {
    0%, 100% {
      transform: scale(0.9) translateZ(0);
      opacity: 0.8;
    }
    50% {
      transform: scale(1.1) translateZ(0);
      opacity: 1;
    }
  }
`;

export default Loader;